/** URL pública del logo de firma (solo para previsualización en el editor). */
export function buildSignatureLogoPublicUrl(logoPath, apiBase) {
  if (!logoPath) return "";
  return `${String(apiBase || "").replace(/\/$/, "")}${logoPath}`;
}

/** Sustituye cid:signature_logo por URL para que TipTap muestre el logo. */
export function resolveSignatureHtmlForCompose(html, logoPath, apiBase) {
  let out = String(html || "");
  if (!out || !logoPath || !/cid:signature_logo/i.test(out)) return out;
  const logoUrl = buildSignatureLogoPublicUrl(logoPath, apiBase);
  return out.replace(/cid:signature_logo/gi, logoUrl);
}

/**
 * Antes de POST /emails/send: vuelve a cid:signature_logo para que el backend
 * adjunte el logo inline (funciona en Gmail, destinatarios y bandeja enviados).
 */
export function signatureHtmlForSend(html, logoPath, apiBase) {
  let out = String(html || "");
  if (!out || !logoPath) return out;
  const logoUrl = buildSignatureLogoPublicUrl(logoPath, apiBase);
  if (!logoUrl) return out;
  const escaped = logoUrl.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  if (new RegExp(escaped, "i").test(out)) {
    out = out.replace(new RegExp(escaped, "gi"), "cid:signature_logo");
  }
  if (/cid:signature_logo/i.test(out)) return out;
  return out;
}
